module.exports = __webpack_public_path__ + "static/media/selected_marker_background.ae803e77.svg";